var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_372_261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 16C23.84 16 25.32 14.5067 25.32 12.6667C25.32 10.8267 23.84 9.33332 22 9.33332C20.16 9.33332 18.6666 10.8267 18.6666 12.6667C18.6666 14.5067 20.16 16 22 16ZM12 14.6667C14.2133 14.6667 15.9866 12.88 15.9866 10.6667C15.9866 8.45332 14.2133 6.66666 12 6.66666C9.78663 6.66666 7.99996 8.45332 7.99996 10.6667C7.99996 12.88 9.78663 14.6667 12 14.6667ZM22 18.6667C19.56 18.6667 14.6666 19.8933 14.6666 22.3333V25.3333H29.3333V22.3333C29.3333 19.8933 24.44 18.6667 22 18.6667ZM12 17.3333C8.89329 17.3333 2.66663 18.8933 2.66663 22V25.3333H12V22.3333C12 21.2 12.44 19.2133 15.16 17.7067C14 17.4667 12.88 17.3333 12 17.3333Z",
    fill: "#ED9C50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_372_261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/card3.54ef173270962d3575ca7c9e2df1b7fb.svg";
export { ForwardRef as ReactComponent };